import { MutationFunction, useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { GetReportsAttachmentFilesPayload } from "./@types";

const getReportsAttachmentFiles: MutationFunction<
  any,
  [GetReportsAttachmentFilesPayload]
> = async ([params]) => {
  const { data } = await apiInputService.get(
    `/report/documents`,
    {
      params: params,
    }
  );

  return data;
};

export const useGetReportsAttachmentFiles = (options?: any) => {
  return useMutation(getReportsAttachmentFiles, {
    ...options,
  });
};
